// extracted by mini-css-extract-plugin
export default {"content":"ApplicationContainer__content__YuDTB"};